import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Checkbox — caixa de seleção acessível.
 *
 * @typedef {Object} CheckboxProps
 * @property {string} [label] Rótulo exibido ao lado do checkbox.
 * @property {boolean} [checked=false] Estado marcado.
 * @property {boolean} [disabled=false] Desabilita o checkbox.
 * @property {boolean} [error=false] Estado de erro.
 * @property {string} [id] Id do input.
 * @property {function} [onChange] Callback de mudança.
 * @property {string} [className] Classes adicionais.
 */

export function Checkbox({ label, checked = false, disabled = false, error = false, id, onChange, className }) {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  return (
    <label
      className={cn(
        'inline-flex cursor-pointer items-center gap-2.5 select-none',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
    >
      <input
        type="checkbox"
        id={inputId}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className={cn(
          'h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-md border bg-white',
          'transition-colors duration-200',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
          'checked:border-primary checked:bg-primary checked:bg-[url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e")] checked:bg-center checked:bg-no-repeat',
          error ? 'border-danger' : 'border-slate-300',
          disabled && 'cursor-not-allowed'
        )}
      />
      {label && <span className="text-sm font-medium text-ink">{label}</span>}
    </label>
  );
}
